import { CountryCode, parsePhoneNumberFromString } from "libphonenumber-js";

export function validatePhoneNumber(phoneNumber: string, countryCode?: CountryCode) {
  try {
    const parsedNumber = parsePhoneNumberFromString(phoneNumber, countryCode);

    if (!parsedNumber) {
      console.log("Invalid phone number format.");
      return false;
    }

    const isValid = parsedNumber.isValid();
    console.log(isValid ? "Valid phone number." : "Invalid phone number.");

    return isValid;
  } catch (error) {
    console.error("Error parsing phone number:", error.message);
    return false;
  }
}
